export default {"src":"/_next/static/media/faq-icon.e3af0304.svg","height":16,"width":16};